__turbopack_context__.v({
  "countChecked": "view-module__wHVBzq__countChecked",
  "countUnchecked": "view-module__wHVBzq__countUnchecked",
  "emoji": "view-module__wHVBzq__emoji",
  "emojiButton": "view-module__wHVBzq__emojiButton",
});
